import { takeEvery, fork, put, all, call } from 'redux-saga/effects';
import { GET_DATA_RETENTION_SETTINGS } from './actionTypes';
import { getDataRetentionSettingsSuccess, getDataRetentionSettingsError } from './actions';
import { getDataRetentionAPI } from '../../../api/dataRetention';

const dataRetentionAPI = getDataRetentionAPI();

function* getDataRetentionSettings({ payload: { user } }) {
  try {
    const response = yield call(dataRetentionAPI.getSettings, user.token);
    yield put(getDataRetentionSettingsSuccess(response.settings, response.message));
  } catch (error) {
    yield put(getDataRetentionSettingsError(error));
  }
}

export function* watchGetDataRetentionSettings() {
  yield takeEvery(GET_DATA_RETENTION_SETTINGS, getDataRetentionSettings);
}

function* getDataRetentionSettingsSaga() {
  yield all([fork(watchGetDataRetentionSettings)]);
}

export default getDataRetentionSettingsSaga;
